export default __webpack_public_path__ + "static/media/Rect1.3ba5ac13.svg";